import React, { useMemo, useState } from 'react';
import {OverlayTrigger,Tooltip} from "react-bootstrap";
import {toAbsoluteUrl} from "../../_helpers";
import { FaExternalLinkAlt} from "react-icons/fa";
import {Modal,Button} from "react-bootstrap";
import VideoIframe from "../widgets/tiles/VideoIframe";
import { MainImagePopup } from '../widgets/tiles/MainImagePopUp';
import SVG from 'react-inlinesvg';
import Availability from '../popup/Availability';
import AdvancedTagSearch from '../popup/AdvancedTagSearch';
import { CopyUrlAlert } from '../widgets/tiles/CopyURLAlert';
import CertificateLink from '../popup/CertificateLink';


export default function  SearchExpandedDetais({data,userinfo,handelDetails}){
    const [showVideo, setShowVideo] = useState(false);
    const [imageBroken, setImageBroken] = useState(false);
    const [imageBrokenAgain, setImageBrokenAgain] = useState(false);
    const [showAssetImg, setShowAssetImg] = useState(false);
    const [showArrowImg, setShowArrowImg] = useState(false);
    const [showHeartImg, setShowHeartImg] = useState(false);
    const [heartBroken, setHeartBroken] = useState(false);
    const [arrowBroken, setArrowBroken] = useState(false);
    const [assetBroken, setAssetBroken] = useState(false);
    const row = data?.original;

    const GenerateTitle = (row) => {
        let title = ""
     
        if(row?.shape){
            title += " "
            title += row?.shape
        }
        if(row?.carat){
            title += " "
            title += row?.carat
        }
       
        if(row?.color){
            title += " "
            title += row?.color
        }
        if(row?.clarity){
            title += " "
            title += row?.clarity
        }

        if(row?.cut){
            title += " "
            title += row?.cut
        }
       
        if(row?.polish){
            title += " "
            title += row?.polish
        }

        if(row?.symmetry){
            title += " "
            title += row?.symmetry
        }

        if(row?.fluorescence){
            title += " "
            title += row?.fluorescence
        }
        return title
    }
    
    function handleClose(event, reason) {
        setShowVideo(false);
        setShowHeartImg(false);
        setShowAssetImg(false);
        setShowArrowImg(false);
    }

    function openVideoModal() {
        setShowVideo(true)
    }

    function openHeartModal() {
        setShowHeartImg(true)
    }

    function openAssetModal() {
        setShowAssetImg(true)
    }

    function openArrowModal() {
        setShowArrowImg(true)
    }


    const [mainimageclick,setMainImageClick] = useState(false)

    


    function discount(x){
        
        let orignal_price = parseFloat(x.oRate * x.carat).toFixed(2);
        let carat_price = parseFloat(orignal_price / x.carat).toFixed(2);
        let discount = (x.cRap||x.rapRate) ? parseFloat((carat_price - (x.cRap || x.rapRate)) / (x.cRap || x.rapRate) * 100).toFixed(2) : "0.00" 
        return parseFloat(discount).toFixed(2);
    }

    return(
       <>
        <div className={`expandedDetails ${row?.isfancy || row?.supplierComment ? "fancyExpand" : "" }`} >
            <div className="row pt-2 m-0">
                <div className="col-3 d-flex">
                    <ul className="img_thumb_box mt-4 ml-5 pl-0">
                        <li className="img_thumb">
                            {row?.image && row?.image != "null" ? (
                                <div>
                                <MainImagePopup Image={row?.image} Shape={row?.shape} mainimageclick={mainimageclick} setMainImageClick={setMainImageClick}/>
                                { imageBroken ? 
                                    <>
                                        {!imageBrokenAgain ?  
                                            <img
                                                className="img-fluid"
                                                alt="shape"
                                                src={toAbsoluteUrl(
                                                    `/media/shape/${row?.shape.toLowerCase()}-no.png`
                                                )}
                                                onError={() => setImageBrokenAgain(true)}
                                            /> 
                                        : 
                                            <img
                                                className="img-fluid"
                                                alt="shape"
                                                src={toAbsoluteUrl(
                                                    `/media/General/NoDiamondImage.svg`
                                                )}
                                            /> 
                                        }
                                    </>
                                :
                                    <img
                                        className="img-fluid cursor-pointer"
                                        alt={row?.shape}
                                        src={`${row?.image}`}
                                        onClick={() => setMainImageClick(true)}
                                        onError={() => setImageBroken(true)}

                                    />
                                }
                                </div>
                            ) : (
                                <div>
                                    <MainImagePopup Image={toAbsoluteUrl( `/media/shape/${row?.shape.toLowerCase()}-no.png` )} Shape={row?.shape} mainimageclick={mainimageclick} setMainImageClick={setMainImageClick}/>
                                    <img
                                        className="img thumb"
                                        alt="shape"
                                        src={toAbsoluteUrl( `/media/shape/${row?.shape.toLowerCase()}-no.png` )}
                                        onError={e => {
                                            e.currentTarget.src = toAbsoluteUrl(
                                                `/media/General/NoDiamondImage.svg`
                                            )
                                        }}
                                    />
                                </div>
                            )}
                        </li>
                        {row?.video  ? (
                            <li className="img_thumb cursor-pointer" onClick={() => openVideoModal()}>
                                <SVG  width="40" src={toAbsoluteUrl("/media/General/videoIcon.svg")} />
                            </li>
                        ):('')}
                        {row?.heart ? (
                            <li className="img_thumb cursor-pointer" onClick={() => openHeartModal()}>
                                <img  alt="img thumb" src="https://assets.diamondsoncall.com/assets/front/images/pd-5.png"/>
                                <SVG  width="40" src={toAbsoluteUrl("/media/General/heartImage.svg")} />
                            </li>
                            
                        ):('')}
                        {row?.arrow ? (
                            <li className="img_thumb cursor-pointer" onClick={() => openArrowModal()}>
                                <SVG  width="40" src={toAbsoluteUrl("/media/General/arrowImage.svg")} />
                            </li>
                        ):('')}
                        {row?.asset ? (
                            <li className="img_thumb cursor-pointer" onClick={() => openAssetModal()}>
                                <SVG  width="40" src={toAbsoluteUrl("/media/General/assetIcon.svg")} />
                            </li>
                        ):('')}
                    </ul>
                    <div className="img_box mt-4">
                        {row?.image && row?.image != "null" ? (
                            <div>
                                <MainImagePopup Image={row?.image} Shape={row?.shape} mainimageclick={mainimageclick} setMainImageClick={setMainImageClick}/>
                                { imageBroken ? 
                                    <>
                                        {!imageBrokenAgain ?  
                                            <img
                                                className="img-fluid"
                                                alt="shape"
                                                onError={() => setImageBrokenAgain(true)}
        
                                                src={toAbsoluteUrl(
                                                    `/media/shape/${row?.shape.toLowerCase()}-no.png`
                                                )}
                                            /> 
                                        : 
                                            <img
                                                className="img-fluid"
                                                alt="shape"
                                                src={toAbsoluteUrl(
                                                    `/media/General/NoDiamondImage.svg`
                                                )}
                                            /> 
                                        }
                                    </>
                                :
                                    <img
                                        className="img-fluid cursor-pointer"
                                        alt={row?.shape}
                                        src={row?.image}
                                        onClick={() => setMainImageClick(true)}
                                        onError={() => setImageBroken(true)}

                                    />
                                }
                            </div>
                        ) : (
                            <div>
                                <MainImagePopup Image={toAbsoluteUrl( `/media/shape/${row?.shape.toLowerCase()}-no.png` )} Shape={row?.shape} mainimageclick={mainimageclick} setMainImageClick={setMainImageClick}/>
                                <img
                                    className="img-fluid"
                                    alt="shape"
                                    src={toAbsoluteUrl(
                                        `/media/shape/${row?.shape.toLowerCase()}-no.png`
                                    )}
                                    onError={e => {
                                        e.currentTarget.src = toAbsoluteUrl(
                                            `/media/General/NoDiamondImage.svg`
                                        )
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-3">
                    <div className="row">
                        <div className="col-10 my-3 justify-content-between d-flex align-items-center">
                           
                            <div ><Availability availability={row?.availability}/><div className="text-primary d-inline-block mr-1">{row?.loatNo}</div><CopyUrlAlert text={row?.loatNo}/></div>
                                <div className=" text-primary">
                                    {row.certificate ? (
                                        <>

                                            <CertificateLink Certificate_link={row.certificate_link} lab={row.lab} certificate={row.certificate} withExternalLinkIcon className={`text-primary mx-2 ml-5 text-left`} />
                                            {row.lab !== "NON" && <CopyUrlAlert text={row.certificate} />}
                                        </>

                                    ) : (
                                        ""
                                    )}
                                </div>
                        </div>
                        <div className="col-10 align-self-center">
                            <span className="text-dark font-size-h4 font-weight-bold text-capitalize">{GenerateTitle(row)}</span>
                        </div>
                        <div className='col-12'><AdvancedTagSearch {...row}/></div>
                        <div className="col-12 mt-4 d-flex">
                            <>
                                <span > 
                                    Location: {row?.location ? row?.location : ''}
                                    <img
                                        className="flagIco ml-1"
                                        alt={row?.location}
                                        src={toAbsoluteUrl(
                                            `/media/map/${row?.location.toLowerCase()}.png`
                                        )}
                                        onError={e => {
                                            e.currentTarget.src =toAbsoluteUrl(
                                                `/media/map/other.png`
                                                )
                                            }}
                                    />
                                </span>
                            </>
                        </div>
                        <div className="col-12 mt-4 d-flex">
                            <span className="font-size-lg text-dark-50"><span className="font-size-sm  text-capitalize">List Price: </span>${row?.listPrice}</span>
                        </div>
                        <div className="col-12 mt-5">
                            <span className="text-muted font-weight-bold font-size-sm">$/CT : ${parseFloat(row?.supplierRate).toFixed(2)}</span>
                            <div className='d-flex align-items-center' ><span className="font-size-h2 font-weight-bold mb-0 d-block">${parseFloat(row?.supplierPrice).toFixed(2) }</span> <span className={`${row?.supplierDiscount >= 0  ? 'text-success' : 'text-danger'} pl-2`}> {parseFloat(row?.supplierDiscount)?row?.supplierDiscount:""}</span></div>
                        </div>
                        <div className="col-12 mt-3">
                            <button type="button" className="btn text-dark text-nowrap btn-light" onClick={()=>handelDetails(data)}> 
                                <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="22.384" height="20.075" viewBox="0 0 22.384 20.075">
                                    <g id="ic_view_details" transform="translate(-794 -623.819)">
                                        <path className="cls-1545654" id="Path_28337" data-name="Path 28337" d="M3.485.017a1.07,1.07,0,0,0-.634.436C2.739.627.071,5.681.037,5.781a.983.983,0,0,0,.013.56c.031.081,1.441,2.053,4.779,6.683,4.366,6.06,4.741,6.574,4.823,6.614a.385.385,0,0,0,.467-.093c.146-.141,9.53-12.848,9.624-13.029a.762.762,0,0,0,.068-.558c-.022-.087-.459-.938-1.442-2.808C17.595,1.674,16.933.43,16.9.386a.927.927,0,0,0-.44-.338L16.345,0,9.966,0C5.978,0,3.548,0,3.485.017ZM8.57,1.377,7.275,3.24c-.652.938-1.19,1.7-1.195,1.69S4.927,1.468,4.864,1.266L4.85,1.222H8.68Zm6.53-.049c-.263.749-1.2,3.386-1.2,3.389s-2.717-3.451-2.724-3.475.672-.02,1.979-.02h1.986l-.038.107ZM4.314,3.569c.352,1.065.642,1.941.642,1.948s-.761.013-1.691.013-1.691,0-1.691-.01.466-.894,1.036-1.974c.628-1.192,1.041-1.955,1.05-1.939s.3.894.656,1.961Zm7.117.029L12.924,5.52l-1.433.005H8.619L7.178,5.52,8.542,3.592c.75-1.061,1.37-1.926,1.379-1.923S10.608,2.54,11.431,3.6Zm5.824.064c.53,1.015.963,1.851.963,1.857s-.743.011-1.653.011c-1.563,0-1.652,0-1.643-.036s1.314-3.677,1.326-3.7.015-.01.024,0,.449.849.98,1.863ZM6.7,10.728c1.723,5.2,1.734,5.24,1.705,5.208S2.982,8.417,1.86,6.852l-.068-.094h3.6L6.7,10.728Zm6.452-3.957c0,.042-3.314,9.424-3.324,9.412S6.714,6.8,6.714,6.771,13.155,6.752,13.155,6.771Zm4.9.022c-.284.4-6.788,9.146-6.793,9.141s.719-2.072,1.605-4.6L14.48,6.754h1.8c1.737,0,1.8,0,1.772.036Z" transform="translate(793.998 623.819)" fill="#212529"/>
                                        <path className="cls-1545654" id="eye" d="M11.958,8.205A6.7,6.7,0,0,0,6.015,4.5,6.7,6.7,0,0,0,.073,8.206a.676.676,0,0,0,0,.61,6.7,6.7,0,0,0,5.943,3.705,6.7,6.7,0,0,0,5.943-3.706A.676.676,0,0,0,11.958,8.205ZM6.015,11.518A3.008,3.008,0,1,1,9.023,8.51,3.008,3.008,0,0,1,6.015,11.518Zm0-5.013a1.991,1.991,0,0,0-.529.079,1,1,0,0,1-1.4,1.4A2,2,0,1,0,6.015,6.505Z" transform="translate(804.354 631.374)" fill="#212529"/>
                                    </g>
                                </svg>
                                Detail
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className="row">
                        <div className="col-6 border-left pb-10">
                            { (row?.isfancy) ? (
                                <>
                                    <div className="font-size-h5 text-dark font-weight-bolder mb-3 mt-5">Fancy Color Details </div>
                                    <div className="row mb-1">
                                        <div className="col-6">Intensity</div>
                                        <div className="col-6 font-weight-bold">  {row?.fancy_intensity ? row?.fancy_intensity : "-"} </div>
                                    </div>
                                    <div className="row mb-1">
                                        <div className="col-6">Overtone</div>
                                        <div className="col-6 font-weight-bold">  {row?.fancy_overtone ? row?.fancy_overtone : "-"} </div>
                                    </div>
                                    <div className="row mb-5">
                                        <div className="col-6">Color</div>
                                        <div className="col-6 font-weight-bold">  {row?.fancy_color ? row?.fancy_color : "-"} </div>
                                    </div>
                                </>
                            ):('')}
                            <div className="font-size-h5 text-dark font-weight-bolder mb-3 mt-5">Parameter Details </div>
                            
                            <div className="row mb-1">
                                <div className="col-6">Measurement</div>
                                <div className="col-6 font-weight-bold"> {row?.length} * {row?.width} * {row?.height} </div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6 ">Table (%) </div>
                                <div className="col-6 font-weight-bold"> {row?.tablePercent} </div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">Depth (%)</div>
                                <div className="col-6 font-weight-bold"> {row?.depthPercent} </div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">CR.Height</div>
                                <div className="col-6 font-weight-bold">{row?.crownHeight}</div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">CR.Angle</div>
                                <div className="col-6 font-weight-bold">{row?.crownAngle}</div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">PAV.Height</div>
                                <div className="col-6 font-weight-bold">{row?.pavilionHeight}</div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">PAV.Angle</div>
                                <div className="col-6 font-weight-bold">{row?.pavilionAngle}</div>
                            </div>
                            {row?.ratio && row?.shape?.toLowerCase() !== "round" ?
                                <div className="row mb-1">
                                    <div className="col-6">Ratio</div>
                                    <div className="col-6 font-weight-bold"> {row?.ratio}</div>
                                </div>
                            :null}
                            <div className="row mb-1">
                                <div className="col-6">Girdle %</div>
                                <div className="col-6 font-weight-bold">{row?.girdle ? row?.girdle : "-"}</div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">Girdle Condition</div>
                                <div className="col-6 font-weight-bold">{row?.girdleCondition  ? row?.girdleCondition : "-"}</div>
                            </div>
                        </div>
                        <div className="col-6 border-left">
                            <h5 className="font-size-h5 text-dark font-weight-bolder mb-3  mt-5">Additional Details</h5>
                            <div className="row mb-1">
                                    <div className="col-6">Brand</div>
                                    <div className="col-6 font-weight-bold">{row?.brand ? row?.brand : "-"}</div>
                                </div>
                            <div className="row mb-1">
                                <div className="col-6">Shade</div>
                                <div className="col-6 font-weight-bold">{row?.shade  ? row?.shade : "-"}</div>
                            </div>
                            <hr className="w-75 ml-0"/>
                            <div className="row mb-1">
                                <div className="col-6">Milky</div>
                                <div className="col-6 font-weight-bold">{row?.milky  ? row?.milky : "-"}</div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">Eye Clean</div>
                                <div className="col-6 font-weight-bold">{row?.eyeClean ? row?.eyeClean : "-"}</div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">Culet</div>
                                <div className="col-6 font-weight-bold"> {row?.culet  ? row?.culet : "-"} </div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">Key to Symbol</div>
                                <div className="col-6 font-weight-bold">{row?.keyToSymbol ? row?.keyToSymbol : "-" }</div>
                            </div>
                            <div className="row mb-1">
                                <div className="col-6">Availability </div>
                                <div className="col-6 font-weight-bold"> {row?.availability ? row?.availability : "-"}</div>
                            </div>
                            {userinfo.type != "Natural" ? 
                                <>
                                    <div className="row mb-1">
                                        <div className="col-6"> Growth Type </div>
                                        <div className="col-6 font-weight-bold">  {row?.growthType ? row?.growthType : "-"} </div>
                                    </div>
                                    {row?.treatment ?
                                        <div className="row mb-1">
                                            <div className="col-6"> Treatment </div>
                                            <div className="col-6 font-weight-bold">  {row?.treatment ? row?.treatment : "-"} </div>
                                        </div>
                                    : "" }
                                </>
                            :   
                                <>
                                    <div className="row mb-1">
                                        <div className="col-6"> Origin </div>
                                        <div className="col-6 font-weight-bold">  {row?.origin ? row?.origin : "-"} </div>
                                    </div>
                                    <div className="row mb-1">
                                        <div className="col-6"> Treatment </div>
                                        <div className="col-6 font-weight-bold">  {row?.treatment ? row?.treatment : "-"} </div>
                                    </div>
                                </>
                            }
                            { row?.supplierComment ?
                                <div className="row mx-0 mt-5">
                                    <div className="col-12 pt-3 px-0 border-top">
                                        <p className="font-size-h4 font-weight-bold text-primary mb-3">Supplier Comment</p>
                                        <div className="row mb-1">
                                    <div className="col-12">{row?.supplierComment}</div>
                                </div>
                                    </div>
                                </div>
                            : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            show={showHeartImg}
            onHide={handleClose}
            size="lg"
        >
            <Modal.Body className="text-center">
                {heartBroken ?
                    <img  src={toAbsoluteUrl(`/media/General/NoDiamondImage.svg`)} height="300px" width="300px" alt={row?.shape} className="img-fluid bg-light rounded" />
                :
                    <img 
                        src={`${row?.heart}`}
                        alt={row?.shape}
                        onError={
                            ()=>
                                setHeartBroken(true)
                        }
                        className="img-fluid" />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal
            show={showArrowImg}
            onHide={handleClose}
            size="lg"
        >
            <Modal.Body className="text-center">
                {arrowBroken ?
                    <img  src={toAbsoluteUrl(`/media/General/NoDiamondImage.svg`)} height="300px" width="300px" alt={row?.shape} className="img-fluid bg-light rounded" />
                :
                    <img 
                        src={row?.arrow}
                        alt={row?.shape} 
                        onError={()=> setArrowBroken(true)}
                        className="img-fluid"
                    />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal
            show={showAssetImg}
            onHide={handleClose}
            size="lg"
        >
            <Modal.Body className="text-center">
                {assetBroken ?
                    <img  src={toAbsoluteUrl(`/media/General/NoDiamondImage.svg`)} height="300px" width="300px" alt={row?.shape} className="img-fluid bg-light rounded" />
                :
                    <img src={`${row?.asset}`} alt={row?.shape}  onError={()=> setAssetBroken(true)}  className="img-fluid" />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                Close
                </Button>
            </Modal.Footer>
        </Modal>
        <VideoIframe
            showVideo={showVideo}
            handleClose={handleClose}
            src={row?.video }
        />
      </>
    )
}